export enum PERMISSION_REQUEST_ERRORS {
    NO_ERROR,
    RECORD_NOT_FOUND,
    RECORD_EXPIRED,
    PIN_IS_INCORRECT,
    TOO_MANY_ATTEMPTS,
    ALREADY_HAS_ACCESS,
    FULL_REG_ERROR,
    PIN_AUTHENTICATION_SUCCESS_EXPIRED,
    PIN_AUTHENTICATION_SUCCESS_MISMATCH,
    GRANTEE_POIDS_MISMATCH,
    GRANTOR_ATTEMPTING_ACCEPT_ACCESS,
    GRANTOR_LOGIN_DETECTED,
}
